import React from 'react';

import MenuLessErrorTemplate from './menuLessErrorTemplate';

const Page403 = () => {
    return <MenuLessErrorTemplate errorCode={403} />;
};

export default Page403;
